
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoaurangabadcab() {



    const cardData =
    {
        keyword: ' Pune to Aurangabad Cab',
        heading: 'Prince Cabs: Pune to Aurangabad Cab',
        headingDescription: 'Prince Cabs offers reliable Pune to Aurangabad Cab services, ideal for business trips, family tours, pilgrimages, and heritage sightseeing. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable journey to Aurangabad, home to Ajanta & Ellora Caves, Bibi Ka Maqbara, and other historical landmarks. With professional chauffeurs, flexible travel plans, and on-time pickups, we make your Pune to Aurangabad journey hassle-free and enjoyable. Travel affordably and conveniently with Prince Cabs’ trusted cab service from Pune to Aurangabad.',

        top: 'Top Places to Visit in Aurangabad with Prince Cabs',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "The Ajanta Caves, a UNESCO World Heritage Site, are world-famous for their stunning rock-cut Buddhist monuments and murals dating back to the 2nd century BC. The caves depict stories from the Jataka tales through breathtaking frescoes and sculptures. Surrounded by a horseshoe-shaped gorge, the site offers both natural beauty and cultural depth. Tourists are mesmerized by the intricate artistry, especially the paintings of Bodhisattva Padmapani and Avalokiteshvara. It is a must-visit for history enthusiasts, art lovers, and spiritual seekers alike."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, another UNESCO World Heritage Site near Aurangabad, showcases 34 rock-cut temples dedicated to Hindu, Buddhist, and Jain traditions. The highlight is the magnificent Kailasa Temple, carved out of a single rock, symbolizing Lord Shiva’s abode. The caves reflect religious harmony and outstanding ancient engineering. Intricate sculptures, halls, and shrines leave visitors in awe of India’s cultural heritage. The site attracts tourists from across the globe. It stands as a timeless masterpiece of devotion and artistry."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Often called the ‘Taj of the Deccan,’ Bibi Ka Maqbara was built in 1678 by Aurangzeb’s son, Azam Shah, in memory of his mother. The monument resembles the Taj Mahal with its Mughal-style architecture, featuring a central dome, minarets, and sprawling gardens. Its marble and stonework reflect exquisite craftsmanship. The site is especially stunning during sunrise and sunset when the monument glows. It is one of Aurangabad’s most visited attractions, blending love, history, and architecture. Tourists admire its serene ambiance and grandeur."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort, also known as Devagiri, is a formidable hilltop fortress about 15 km from Aurangabad. Built in the 12th century, it was once the capital of the Yadava dynasty and later used by several rulers. The fort is renowned for its ingenious defense systems, massive gates, and steep climb. Visitors are awed by its bastions, moats, and tunnels designed to protect against invasions. The panoramic views from the top are breathtaking. It is a must-visit for history buffs and adventure seekers."
  },
  {
    "title": "Aurangabad Caves",
    "description": "The Aurangabad Caves, dating back to the 6th–7th centuries, are a group of 12 rock-cut Buddhist shrines carved out of soft basalt rock. They are less crowded compared to Ajanta and Ellora but equally fascinating. The caves feature intricate sculptures of deities like Bodhisattvas and Tara, reflecting Buddhist Tantric traditions. Their hilltop location offers scenic views of the city below. The site is peaceful and ideal for photography and quiet exploration. It provides a glimpse into Aurangabad’s lesser-known heritage."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki, meaning ‘water mill,’ is a 17th-century engineering marvel built to grind grain for pilgrims and disciples of a Sufi saint. The system used underground water channels from a nearby river to power the mill. Today, the site features a beautiful garden, fountains, and a tank filled with fish. Visitors are fascinated by its historical water management system. The adjoining dargah adds spiritual importance. Panchakki reflects Aurangabad’s blend of history, utility, and spirituality."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Located near Ellora, Grishneshwar Temple is one of the 12 sacred Jyotirlingas of Lord Shiva. Built in red basalt stone, the temple showcases intricate carvings and sculptures. Devotees from across India visit to seek blessings and perform rituals. The temple’s sanctum houses the revered Shiva lingam, worshipped with deep devotion. Its proximity to Ellora makes it convenient for pilgrims and tourists alike. Festivals like Mahashivratri see thousands of devotees gathering here. It is a major spiritual landmark in Aurangabad."
  },
  {
    "title": "Salim Ali Lake & Bird Sanctuary",
    "description": "Salim Ali Lake, named after India’s famous ornithologist, is a tranquil spot in Aurangabad. The adjoining bird sanctuary attracts numerous migratory and resident bird species, making it a paradise for birdwatchers. The lake’s scenic setting is perfect for picnics and morning walks. Boating facilities add to the visitor experience. During winter, the sanctuary becomes vibrant with colorful flocks of birds. It offers a refreshing break from the city’s historical sites. Nature lovers find it an ideal retreat."
  },
  {
    "title": "Siddharth Garden and Zoo",
    "description": "Siddharth Garden is a well-maintained park in Aurangabad, popular among families for its greenery, fountains, and peaceful ambiance. The garden also houses a small zoo featuring tigers, leopards, and a variety of birds. It’s a favorite picnic spot for children and locals. The garden’s location near Bibi Ka Maqbara makes it convenient for tourists. Evening walks here are relaxing amidst the landscaped lawns. It is a simple yet enjoyable spot for leisure and family outings."
  },
  {
    "title": "Soneri Mahal",
    "description": "Soneri Mahal, meaning ‘Golden Palace,’ is a 17th-century palace built by a Bundelkhand chief. Once adorned with golden paintings, it now houses a museum displaying ancient artifacts, sculptures, and paintings. The palace is located within the Dr. Babasaheb Ambedkar Marathwada University campus. Its elegant Mughal-style architecture and historical exhibits attract culture enthusiasts. Cultural programs and festivals are often held here. It is a hidden gem that adds to Aurangabad’s charm and heritage trail."
  }
],


"services": [
    {
        "name": "Pune to Aurangabad Taxi",
        "description": "Experience a smooth and comfortable taxi journey from Pune to Aurangabad with our reliable services. Whether you're traveling for business, sightseeing, or family visits, our well-maintained vehicles and professional drivers ensure a safe, timely, and pleasant trip. We prioritize customer convenience with flexible pickup and drop timings, door-to-door service, and competitive pricing."
    },
    {
        "name": "Pune Aurangabad Innova Cab Service",
        "description": "Travel in style and comfort with our Innova cab service from Pune to Aurangabad. Perfect for families and groups, the Innova offers spacious seating, air conditioning, and ample luggage space. Our experienced drivers are familiar with the route and traffic conditions, ensuring a hassle-free and enjoyable journey. Book with us for punctual service, clean vehicles, and affordable rates."
    },
    {
        "name": "Pune to Sambhaji Nagar Cab",
        "description": "Book a convenient cab service from Pune to Sambhaji Nagar (Aurangabad) for your travel needs. Our taxis provide a reliable and safe ride with professional drivers, ensuring timely arrival. Whether you are heading for work, pilgrimage, or leisure, enjoy comfortable seating and courteous service throughout the trip."
    },
    {
        "name": "Pune to Aurangabad Etios Taxi",
        "description": "Choose our Toyota Etios taxi for an economical and comfortable journey from Pune to Aurangabad. The Etios sedan offers great mileage, smooth ride quality, and air conditioning, making it ideal for solo travelers and small families. With experienced drivers and transparent pricing, your trip will be both pleasant and budget-friendly."
    },
    {
        "name": "Pune to Aurangabad Round Trip Cab",
        "description": "Opt for our round trip cab service between Pune and Aurangabad for a stress-free travel experience. Whether you plan a short visit or an extended stay, having a dedicated vehicle and driver ensures flexibility, safety, and comfort. Take advantage of our customized packages including sightseeing stops and local travel options."
    },
    {
        "name": "Pune to Aurangabad Tour Package",
        "description": "Explore Aurangabad’s famous attractions like Ajanta and Ellora caves with our comprehensive tour packages from Pune. Our packages include cab transportation, professional drivers, and options for guided tours. Enjoy a hassle-free travel experience tailored to your interests and schedule."
    },
    {
        "name": "Pune to Grishneshwar Cab Service",
        "description": "Visit the sacred Grishneshwar temple with our dedicated cab service from Pune to Aurangabad. Our drivers know the best routes and local tips to make your pilgrimage smooth and timely. Comfortable vehicles and door-to-door service ensure a peaceful journey for devotees."
    },
    {
        "name": "Pune to Aurangabad Dzire Taxi",
        "description": "Book a Dzire taxi for a reliable and comfortable ride from Pune to Aurangabad. Ideal for couples and small families, the Dzire offers air conditioning and a smooth ride with professional drivers who prioritize safety and customer satisfaction."
    },
    {
        "name": "Pune to Aurangabad Innova Crysta Taxi",
        "description": "Travel with extra comfort and space in our Innova Crysta taxi service from Pune to Aurangabad. With plush interiors, advanced features, and courteous drivers, this premium vehicle is perfect for business trips, family outings, and group travel. We ensure punctual pickups and transparent pricing."
    },
    {
        "name": "Pune to Aurangabad Affordable Cab",
        "description": "Choose our affordable cab services from Pune to Aurangabad without compromising on comfort or safety. We offer competitive rates with no hidden charges and maintain high standards of vehicle hygiene and driver professionalism, making your travel both budget-friendly and enjoyable."
    },
    {
        "name": "Pune to Aurangabad Family Cab",
        "description": "Plan your family trip from Pune to Aurangabad with our dedicated family cab services. Equipped with child-friendly amenities, ample luggage space, and spacious seating, our cabs provide a safe and comfortable environment for travelers of all ages. Our courteous drivers ensure a stress-free journey for you and your loved ones."
    }
],
"tableData": [
    ["Pune to Aurangabad Taxi", "Pune Aurangabad Innova Cab Service"],
    ["Pune to Sambhaji Nagar Cab", "Pune to Aurangabad Etios Taxi"],
    ["Pune to Aurangabad Round Trip Cab", "Pune to Aurangabad Tour Package"],
    ["Pune to Grishneshwar Cab Service", "Pune to Aurangabad Dzire Taxi"],
    ["Pune to Aurangabad Innova Crysta Taxi", "Pune to Aurangabad Affordable Cab"],
    ["Pune to Aurangabad Family Cab", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Aurangabad Cab Service",
        "WhyChoosedescription": "Prince Cabs provides a trustworthy and efficient cab service from Pune to Aurangabad, perfect for leisure travelers, business visitors, and tourists exploring the Ajanta and Ellora caves. We pride ourselves on punctual pickups, comfortable journeys, and professional service that ensures you reach your destination safely and on time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles for Long Distance Travel",
        "WhyChoosedescription": "Our fleet consists of well-maintained, air-conditioned vehicles designed to offer maximum comfort on long journeys. With ergonomic seating, ample legroom, and sufficient luggage space, you can relax and enjoy the scenic drive from Pune to Aurangabad without worrying about cramped conditions or discomfort."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with the Route and Terrain",
        "WhyChoosedescription": "Our drivers are highly experienced and knowledgeable about the Pune to Aurangabad route, including traffic patterns, best pit stops, and safety precautions for long-distance travel. Their courteous and professional approach ensures a smooth ride, allowing you to sit back and enjoy the journey stress-free."
    },
    {
        "WhyChooseheading": "Flexible Booking and Customized Travel Plans",
        "WhyChoosedescription": "Prince Cabs offers flexible booking options including one-way trips, round trips, and multi-day rentals to accommodate your travel schedule. Whether you want to make stops at tourist attractions along the way or require specific timing, we tailor our services to fit your unique needs."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Standards",
        "WhyChoosedescription": "We prioritize your health and safety by maintaining strict hygiene protocols. Every vehicle is thoroughly cleaned and sanitized before and after each trip. Regular maintenance ensures that our fleet is in top condition, providing you a safe and worry-free travel experience."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Secure Payment Options",
        "WhyChoosedescription": "Our pricing is competitive and clearly communicated with no hidden charges, giving you peace of mind. We offer various secure payment methods including UPI, credit/debit cards, net banking, and cash to make your booking and payment process convenient and hassle-free."
    },
    {
        "WhyChooseheading": "Dedicated 24/7 Customer Support for a Smooth Experience",
        "WhyChoosedescription": "Our customer support team is available round the clock to assist you with bookings, route information, or any travel-related queries. We aim to provide a seamless and enjoyable travel experience, addressing your concerns promptly and ensuring your trip from Pune to Aurangabad goes without a hitch."
    }
]























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Aurangabad cab services?',
        answer: 'Yes, Prince Cabs provides safe and comfortable cab services from Pune to Aurangabad, ideal for business trips, sightseeing, and family travel.',
    },
    {
        question: 'What cab options are available for Pune to Aurangabad travel?',
        answer: 'We offer hatchbacks, sedans, SUVs, and tempo travellers to meet the travel needs of individuals, families, and larger groups.',
    },
    {
        question: 'Are your cabs suitable for long-distance journeys like Pune to Aurangabad?',
        answer: 'Absolutely! Our vehicles are spacious, air-conditioned, and maintained for comfort and safety during long-distance travel.',
    },
    {
        question: 'Can I customize my travel plan for the Pune to Aurangabad route?',
        answer: 'Yes, we offer flexible travel options with customizable pickup points, drop locations, and stopovers at popular spots like Ellora or Daulatabad Fort.',
    },
    {
        question: 'What are the charges for a Pune to Aurangabad cab?',
        answer: 'Cab fares vary based on vehicle type, travel duration, and itinerary. Contact Prince Cabs for a personalized and transparent quote.',
    },
    {
        question: 'How do I book a Pune to Aurangabad cab with Prince Cabs?',
        answer: 'Booking is easy—call us or use our website to share your travel details, and we’ll help you select the best cab for your trip.',
    },
    {
        question: 'Are the cabs cleaned and well-maintained for intercity travel?',
        answer: 'Yes, all our vehicles are thoroughly cleaned, sanitized, and serviced regularly to ensure a safe and pleasant journey to Aurangabad.',
    },
];

const testimonials = [
    {
        name: "Mr. Sameer Kulkarni",
        position: "History Enthusiast",
        text: "I booked a Pune to Aurangabad cab with Prince Cabs to visit the Ajanta and Ellora caves. The ride was smooth and the driver was very knowledgeable about the area.",
        image: "/img/testimonial/testimonial-thumb-aurangabad-1.png",
    },
    {
        name: "Mrs. Aarti Deshpande",
        position: "Family Traveler",
        text: "Our Pune to Aurangabad trip was very comfortable with Prince Cabs. The vehicle was clean, and the driver was polite and punctual.",
        image: "/img/testimonial/testimonial-thumb-aurangabad-2.png",
    },
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Aurangabad Cab",
  "image": "https://princecab.com/assets/images/pune-aurangabad-cab.jpg",
  "description": "Book Pune to Aurangabad cab with Prince Cabs for comfortable and affordable travel. Options include Innova Crysta, Dzire, and Etios taxis ideal for Sambhaji Nagar, Grishneshwar tours, round trips, and family travel. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6450"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5200",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-aurangabad-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Aurangabad Cab | Sambhaji Nagar & Grishneshwar Tours | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Aurangabad cab service with Innova, Dzire, and Etios options. Ideal for Sambhaji Nagar, Grishneshwar tours, round trips, and family travel. Affordable fares with 24/7 online booking."
  />
  <meta
    name="keywords"
    content="Pune to Aurangabad Taxi, Pune Aurangabad Innova Cab Service, Pune to Sambhaji Nagar Cab, Pune to Aurangabad Etios Taxi, Pune to Aurangabad Round Trip Cab, Pune to Aurangabad Tour Package, Pune to Grishneshwar Cab Service, Pune to Aurangabad Dzire Taxi, Pune to Aurangabad Innova Crysta Taxi, Pune to Aurangabad Affordable Cab, Pune to Aurangabad Family Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/10.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoaurangabadcab;